import { queryOptions } from '@tanstack/react-query'
import { z } from 'zod'
import { apiRequest } from '@/shared/api'
import { CustomerAccountListItemSchema, ProjectAccessItemSchema } from '../model/types'

export const customerAccountKeys = {
  byCompany: (companyId: string) => ['customer-account', 'company', companyId] as const,
  projectAccess: (accountId: string) => ['customer-account', 'project-access', accountId] as const,
}

// Люди компании (bounded, конверт {items}).
export function companyAccountsQueryOptions(companyId: string) {
  return queryOptions({
    queryKey: customerAccountKeys.byCompany(companyId),
    queryFn: async () => {
      const body = await apiRequest<{ items: unknown[] }>({
        method: 'GET',
        url: `/companies/${companyId}/accounts`,
      })
      return z.array(CustomerAccountListItemSchema).parse(body.items)
    },
  })
}

// Проекты, выданные человеку.
export function accountProjectAccessQueryOptions(accountId: string) {
  return queryOptions({
    queryKey: customerAccountKeys.projectAccess(accountId),
    queryFn: async () => {
      const body = await apiRequest<{ items: unknown[] }>({
        method: 'GET',
        url: `/customer-accounts/${accountId}/project-access`,
      })
      return z.array(ProjectAccessItemSchema).parse(body.items)
    },
  })
}
